import styled from '@emotion/styled';

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;

  label {
    font-weight: 500;
    margin: 0;
    order: 1;
  }

  input {
    order: 0;
    width: 16px;
    margin-right: 16px;
  }
`;

export const DatePickerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  .text {
    margin: 0;
    color: #72747b;
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .button {
    min-height: 36px;
  }
`;
